import { useState } from 'react'
import api from '../services/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await api.post('/password-reset/request', { email })
      setDone(true)
    } catch (err: any) {
      setError(err.response?.data?.error || 'エラーが発生しました')
    } finally {
      setLoading(false)
    }
  }

  if (done) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>メールを送信しました</h1>
          <p style={styles.message}>
            入力されたメールアドレスにパスワードリセット用のリンクを送信しました。
          </p>
          <p style={styles.note}>※メールが届かない場合は迷惑メールフォルダをご確認ください</p>
          <a href="/login" style={styles.button}>ログインページへ戻る</a>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>パスワードをお忘れの方</h1>
        <p style={styles.message}>
          登録済みのメールアドレスを入力してください。パスワードリセット用のリンクをお送りします。
        </p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>メールアドレス</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="example@email.com"
              required
            />
          </div>
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? '送信中...' : 'リセットメールを送信'}
          </button>
        </form>
        <p style={styles.link}>
          <a href="/login">ログインページへ戻る</a>
        </p>
      </div>
    </div>
  )
}

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: '20px'
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px'
  },
  title: { textAlign: 'center', marginBottom: '16px', color: '#333' },
  message: { color: '#555', fontSize: '14px', marginBottom: '24px', textAlign: 'center' },
  note: { color: '#888', fontSize: '12px', marginBottom: '24px', textAlign: 'center' },
  field: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '4px', color: '#555', fontSize: '14px' },
  input: { width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px', boxSizing: 'border-box' },
  button: {
    display: 'block',
    width: '100%',
    padding: '12px',
    backgroundColor: '#1F4E79',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    textAlign: 'center',
    textDecoration: 'none',
    boxSizing: 'border-box'
  },
  error: { color: 'red', marginBottom: '16px', fontSize: '14px' },
  link: { textAlign: 'center', marginTop: '16px', fontSize: '14px' }
}
